/* 873.IL — one small file, no libraries. */
(() => {
  const T = window.T873 || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const html = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- drawers: menu / cart / search ---------- */
  let openName = null, lastFocus = null;
  const scrim = () => $('[data-scrim]');
  const drawer = (n) => $(`[data-drawer="${n}"]`);

  function open(name) {
    if (openName && openName !== name) close(true);
    const d = drawer(name); if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    html.classList.add('html-lock');
    $$(`[data-open="${name}"]`).forEach(b => b.setAttribute('aria-expanded', 'true'));
    if (name === 'cart') { const s = scrim(); s.hidden = false; requestAnimationFrame(() => s.classList.add('is-on')); }
    openName = name;
    setTimeout(() => {
      const f = name === 'search' ? $('[data-search-input]') : $('[data-close]', d);
      f && f.focus({ preventScroll: true });
    }, 60);
    return true;
  }
  function close(silent) {
    if (!openName) return;
    const d = drawer(openName);
    d && d.classList.remove('is-open');
    $$(`[data-open="${openName}"]`).forEach(b => b.setAttribute('aria-expanded', 'false'));
    const s = scrim(); s.classList.remove('is-on'); setTimeout(() => { if (!s.classList.contains('is-on')) s.hidden = true; }, 360);
    html.classList.remove('html-lock');
    openName = null;
    if (!silent && lastFocus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]');
    if (o) { if (open(o.dataset.open)) e.preventDefault(); return; }
    if (e.target.closest('[data-close]') || e.target.closest('[data-scrim]')) { close(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
    if (e.key === 'Tab' && openName) {           // keep focus inside the open drawer
      const d = drawer(openName);
      const f = $$('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', d).filter(x => x.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- header shrink ---------- */
  const hdrGroup = () => $('.hdr-sec');
  let ticking = false;
  const onScroll = () => {
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => {
      const g = hdrGroup(); g && g.classList.toggle('is-scrolled', scrollY > 40);
      drift(); ticking = false;
    });
  };
  addEventListener('scroll', onScroll, { passive: true });

  /* ---------- reveal ---------- */
  function reveal(root = document) {
    const els = $$('[data-reveal],[data-reveal-img],[data-hero]', root);
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(el => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((ents) => ents.forEach(en => {
      // anything already scrolled past (anchor jumps) is revealed too
      if (en.isIntersecting || en.boundingClientRect.top < 0) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    els.forEach(el => io.observe(el));
  }

  /* ---------- statement drift ---------- */
  function drift() {
    if (reduce) return;
    $$('[data-drift]').forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) return;
      const p = (innerHeight - r.top) / (innerHeight + r.height);   // 0 → 1 while it crosses
      el.style.transform = `translate3d(0,${(0.5 - p) * 48}px,0)`;
    });
  }

  /* ---------- fit giant type to its box: never clipped, never wider than the column ---------- */
  function fit() {
    $$('[data-fit],[data-drift]').forEach(el => {
      el.style.fontSize = '';
      const cs = getComputedStyle(el), max = parseFloat(cs.fontSize);
      const avail = el.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      const parts = $$('.ln > span', el), targets = parts.length ? parts : [el];
      const w = Math.max(...targets.map(t => { const rg = document.createRange(); rg.selectNodeContents(t); return rg.getBoundingClientRect().width; }));
      if (w > 0 && avail > 0) el.style.fontSize = Math.min(max, max * avail / w * 0.98) + 'px';
    });
  }
  let fitT;
  addEventListener('resize', () => { clearTimeout(fitT); fitT = setTimeout(fit, 120); });

  /* ---------- cart ---------- */
  async function renderCart(sections) {
    let htmlStr = sections && sections['cart-drawer'];
    if (!htmlStr) {
      const r = await fetch(`${T.root.replace(/\/$/, '')}/?sections=cart-drawer`);
      htmlStr = (await r.json())['cart-drawer'];
    }
    const doc = new DOMParser().parseFromString(htmlStr, 'text/html');
    const fresh = $('[data-drawer="cart"]', doc), cur = drawer('cart');
    if (fresh && cur) {
      cur.innerHTML = fresh.innerHTML;
      const n = +fresh.dataset.count || 0;
      $$('[data-cart-count]').forEach(el => el.textContent = n);
      $$('[data-cart-num]').forEach(el => el.textContent = n);
      $$('[data-cart-icon]').forEach(el => { el.classList.toggle('has-items', n > 0); el.setAttribute('aria-label', `סל, ${n} פריטים`); });
    }
  }
  async function addToCart(items, btn) {
    btn && btn.classList.add('is-loading');
    open('cart'); drawer('cart').classList.add('is-busy');   // open at once, fill when the server answers
    try {
      const r = await fetch(T.cartAdd.replace(/\/?$/, '.js').replace('.js.js', '.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: 'cart-drawer' })
      });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || 'משהו השתבש');
      await renderCart(j.sections);
      return true;
    } catch (err) {
      const box = btn && btn.closest('form') && $('[data-form-error]', btn.closest('form'));
      close(true);
      if (box) { box.textContent = err.message; box.hidden = false; } else alert(err.message);
      return false;
    } finally { btn && btn.classList.remove('is-loading'); drawer('cart').classList.remove('is-busy'); }
  }
  async function changeLine(line, quantity) {
    const d = drawer('cart'); d.classList.add('is-busy');
    try {
      const r = await fetch(T.cartChange.replace(/\/?$/, '.js').replace('.js.js', '.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: +line, quantity: +quantity, sections: 'cart-drawer' })
      });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message);
      await renderCart(j.sections);
    } catch (err) { alert(err.message); }
    finally { drawer('cart').classList.remove('is-busy'); }
  }
  document.addEventListener('click', (e) => {
    const qa = e.target.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); addToCart([{ id: +qa.dataset.quickAdd, quantity: 1 }], qa); return; }
    const q = e.target.closest('[data-qty][data-line]');
    if (q && q.closest('[data-drawer="cart"]')) { changeLine(q.dataset.line, q.dataset.qty); }
  });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-product-form]'); if (!f) return;
    e.preventDefault();
    const fd = new FormData(f);
    const err = $('[data-form-error]', f); if (err) err.hidden = true;
    const items = [{ id: +fd.get('id'), quantity: Math.max(1, +fd.get('quantity') || 1) }];
    const now = e.submitter && e.submitter.hasAttribute('data-buy-now') ? e.submitter : null;
    if (now) { buyNow(items, now, f); return; }
    addToCart(items, $('[data-atc]', f));
  });
  // "קנה עכשיו": add, then straight to checkout, no drawer
  async function buyNow(items, btn, form) {
    btn.classList.add('is-loading');
    try {
      const r = await fetch(T.cartAdd.replace(/\/?$/, '.js').replace('.js.js', '.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || 'משהו השתבש');
      location.href = btn.value || '/checkout';
    } catch (err) {
      const box = $('[data-form-error]', form);
      if (box) { box.textContent = err.message; box.hidden = false; }
      btn.classList.remove('is-loading');
    }
  }

  /* ---------- quantity steppers on the product page ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-step]'); if (!b) return;
    const inp = $('input[type="number"]', b.parentElement); if (!inp) return;
    const max = inp.max ? +inp.max : 99;
    inp.value = Math.min(max, Math.max(1, (+inp.value || 1) + +b.dataset.step));
  });

  /* ---------- predictive search ---------- */
  let sTimer, sCtrl;
  async function predictive(q) {
    const out = $('[data-search-results]'), idle = $('[data-search-idle]');
    if (!q.trim()) { out.innerHTML = ''; idle && (idle.hidden = false); return; }
    sCtrl && sCtrl.abort(); sCtrl = new AbortController();
    const qs = `?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&section_id=predictive-search`;
    const base = (T.search || '/search/suggest');
    let r;
    try {
      r = await fetch(base + qs, { signal: sCtrl.signal });
      // Shopify rejects some buyer locales here (417) — the English route returns the same catalogue
      if (!r.ok) r = await fetch('/en/search/suggest' + qs, { signal: sCtrl.signal });
      if (!r.ok) return;
      let t = await r.text();
      t = t.replace(/href="\/en\//g, 'href="/');
      const doc = new DOMParser().parseFromString(t, 'text/html');
      const sec = doc.querySelector('.shopify-section') || doc.body;
      out.innerHTML = sec.innerHTML;
      idle && (idle.hidden = true);
    } catch (_) { /* aborted */ }
  }
  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-search-input]')) return;
    clearTimeout(sTimer); sTimer = setTimeout(() => predictive(e.target.value), 220);
  });

  /* ---------- card image swipe pips ---------- */
  document.addEventListener('scroll', (e) => {
    const el = e.target; if (!(el instanceof Element) || !el.matches('[data-card-imgs]')) return;
    const i = Math.round(Math.abs(el.scrollLeft) / el.clientWidth);
    const pips = el.parentElement.querySelectorAll('.card__pips i');
    pips.forEach((p, k) => p.classList.toggle('on', k === i));
  }, true);

  /* ---------- product gallery counter + sticky add to bag ---------- */
  function pdp() {
    const pg = $('[data-pg]');
    if (pg) {
      const n = pg.children.length, idx = $('[data-pg-i]'), bar = $('[data-pg-bar]');
      pg.addEventListener('scroll', () => {
        const i = Math.round(Math.abs(pg.scrollLeft) / pg.clientWidth);
        idx && (idx.textContent = i + 1);
        bar && bar.style.setProperty('--x', `${(html.dir === 'rtl' ? -1 : 1) * i * 100}%`);
      }, { passive: true });
    }
    const atc = $('[data-atc]'), sticky = $('[data-sticky-atc]');
    if (atc && sticky) {
      // scroll check, not IntersectionObserver: a fast jump past the button never fires IO
      const buy = $('[data-sticky-buy]', sticky);
      const check = () => {
        const r = atc.getBoundingClientRect();
        const on = r.bottom < 0 || (r.top > innerHeight && scrollY > 160);
        sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); buy.tabIndex = on ? 0 : -1;
      };
      addEventListener('scroll', () => requestAnimationFrame(check), { passive: true });
      addEventListener('resize', check); check();
      buy.addEventListener('click', () => atc.click());
    }
    const reco = $('[data-reco]');
    if (reco && !reco.children.length) {
      fetch(reco.dataset.url).then(r => r.text()).then(t => {
        const doc = new DOMParser().parseFromString(t, 'text/html');
        const s = $('[data-reco]', doc);
        if (s && s.innerHTML.trim()) { reco.innerHTML = s.innerHTML; reveal(reco); }
      }).catch(() => {});
    }
  }

  /* ---------- collection: filters + sort ---------- */
  function collection() {
    const t = $('[data-toggle-filters]'), p = $('[data-fpanel]');
    t && p && t.addEventListener('click', () => { p.hidden = !p.hidden; t.setAttribute('aria-expanded', String(!p.hidden)); });
    const s = $('[data-sort]');
    s && s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u; });
    const f = $('[data-filter-form]');
    f && f.addEventListener('change', (e) => { if (e.target.type === 'checkbox') f.requestSubmit ? f.requestSubmit() : f.submit(); });
  }

  /* ---------- theme editor ---------- */
  document.addEventListener('shopify:section:load', (e) => { fit(); reveal(e.target); drift(); });

  /* ---------- gallery lightbox ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-lb]'); if (!b) return;
    const lb = document.createElement('div');
    lb.className = 'lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = `<img src="${b.dataset.lb}" alt=""><button class="icon-btn" type="button" aria-label="סגירה"><svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5 5 19"/></svg></button>`;
    const shut = () => { lb.remove(); html.classList.remove('html-lock'); b.focus(); document.removeEventListener('keydown', esc); };
    const esc = (k) => { if (k.key === 'Escape') shut(); };
    lb.addEventListener('click', (x) => { if (x.target === lb || x.target.closest('button')) shut(); });
    document.addEventListener('keydown', esc);
    document.body.appendChild(lb); html.classList.add('html-lock'); $('button', lb).focus();
  });

  const init = () => { fit(); reveal(); pdp(); collection(); onScroll(); document.fonts && document.fonts.ready.then(fit); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();

/* ---------- accessibility menu (settings persist per browser) ---------- */
(() => {
  const html = document.documentElement, KEY = 'a873';
  const load = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (_) { return {}; } };
  const save = (s) => { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (_) {} };
  let st = load();
  const apply = () => {
    ['s1','s2','s3'].forEach(c => html.classList.remove('a11y-' + c));
    if (st.size > 0) html.classList.add('a11y-s' + st.size);
    ['contrast','links','readable','still'].forEach(k => {
      html.classList.toggle('a11y-' + k, !!st[k]);
      document.querySelectorAll('[data-a11y="' + k + '"]').forEach(b => b.setAttribute('aria-pressed', st[k] ? 'true' : 'false'));
    });
  };
  apply();
  const panel = () => document.getElementById('a11y');
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-a11y-open]');
    if (o) { const p = panel(); const show = p.hidden; p.hidden = !show; o.setAttribute('aria-expanded', String(show)); if (show) p.querySelector('button').focus(); return; }
    if (e.target.closest('[data-a11y-close]')) { panel().hidden = true; const b = document.querySelector('[data-a11y-open]'); b.setAttribute('aria-expanded','false'); b.focus(); return; }
    const sz = e.target.closest('[data-a11y-size]');
    if (sz) { st.size = Math.max(0, Math.min(3, (st.size || 0) + +sz.dataset.a11ySize)); save(st); apply(); return; }
    const t = e.target.closest('[data-a11y]');
    if (t) { const k = t.dataset.a11y; st[k] = !st[k]; save(st); apply(); return; }
    if (e.target.closest('[data-a11y-reset]')) { st = {}; save(st); apply(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && panel() && !panel().hidden) { panel().hidden = true; } });
  // lift the floating buttons above the mobile sticky add-to-bag bar
  const sticky = document.querySelector('[data-sticky-atc]');
  if (sticky) new MutationObserver(() => html.classList.toggle('has-sticky', sticky.classList.contains('is-on'))).observe(sticky, { attributes: true, attributeFilter: ['class'] });
})();
